// 토스트 (live region 적용)
import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'
import type { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type ToastKind = 'success' | 'error' | 'info'
export interface ToastItem { id: string; kind: ToastKind; text: string }

interface ToastCtx { push: (kind: ToastKind, text: string) => void }
const Ctx = createContext<ToastCtx>({ push: () => {} })

export function useToast() { return useContext(Ctx) }

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([])
  const timers = useRef<Record<string, number>>({})

  const push = useCallback((kind: ToastKind, text: string) => {
    const id = Math.random().toString(36).slice(2)
    setItems((cur) => [...cur, { id, kind, text }])
    timers.current[id] = window.setTimeout(() => {
      setItems((cur) => cur.filter((t) => t.id !== id))
      delete timers.current[id]
    }, 4500)
  }, [])

  useEffect(() => () => { Object.values(timers.current).forEach(clearTimeout) }, [])

  return (
    <Ctx.Provider value={{ push }}>
      {children}
      <div className="toast-region" role="region" aria-live="polite" aria-label="알림">
        {items.map((t) => (
          <div key={t.id} className={`toast ${t.kind}`}>
            <FontAwesomeIcon
              icon={
                t.kind === 'success'
                  ? 'circle-check'
                  : t.kind === 'error'
                    ? 'circle-exclamation'
                    : 'circle-info'
              }
              aria-hidden="true"
            />
            <span>{t.text}</span>
          </div>
        ))}
      </div>
    </Ctx.Provider>
  )
}
